export interface NavigationTarget {
  to: string
}

function matchesPath(activePath: string, targetPath: string): boolean {
  if (targetPath === '/customer') return activePath === targetPath
  return activePath === targetPath || activePath.startsWith(`${targetPath}/`)
}

export function activeNavigationPath(items: NavigationTarget[], activePath: string): string | undefined {
  return items
    .filter((item) => matchesPath(activePath, item.to))
    .sort((left, right) => right.to.length - left.to.length)[0]?.to
}
